import React from 'react'
import { Box, ButtonGroup , IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from 'react-redux';
import { PaginationDetails } from "../../Utils/Utils";
import styles from "./Roles.module.css"
import { openDeleteRoleModal, openEditRoleModal } from "../../Store/Slices/brSlice";
import { useState } from 'react';
import { useEffect } from 'react';

const RolesTable = ({ data }) => {

    const dispatch = useDispatch();
    const [roles, setRoles] = useState("")

    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("role"));
        }
      }
      getRoles()
    }, [])

    const { page, count, handleChange, _DATA } = PaginationDetails(data);

    return (
        <>
            <TableContainer className={styles.container}>
                <Table stickyHeader aria-label="simple table" className={styles.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell width={100}>Id</TableCell>
                            <TableCell width={200}>Name</TableCell>
                            <TableCell align="center" width={'30%'}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {_DATA.currentData()?.map((role) => (
                            <TableRow className={styles.row} key={role.brId}>
                                <TableCell className={styles.tCell} component="th" scope="row">
                                    #{role.brId}
                                </TableCell>
                                <TableCell className={styles.tCell}>{role.brName}</TableCell>
                                <TableCell className={styles.tCell} align="center">
                                    <ButtonGroup variant="text" aria-label="text button group">
                                        {roles?.split(",").includes("PRIV_ECOM_EDITBR") && <IconButton onClick={() => {dispatch(openEditRoleModal(role.brId))}}>
                                            <Edit />
                                        </IconButton>}
                                        {roles?.split(",").includes("PRIV_ECOM_DELETEBR") && <IconButton onClick={() => {dispatch(openDeleteRoleModal(role.brId))}}>
                                            <Delete />
                                        </IconButton>}
                                    </ButtonGroup>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    size="large"
                    page={page}
                    variant="outlined"
                    color="primary"
                    onChange={handleChange}
                    className={styles.pagination}
                />
            </Box>
        </>
    )
}

export default RolesTable